function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { useEffect } from 'react';
import { isFunction } from '../utils';
import isDev from '../utils/isDev';

var useMount = function useMount(fn) {
  if (isDev) {
    if (!isFunction(fn)) {
      console.error("useMount: parameter `fn` expected to be a function, but got \"".concat(_typeof(fn), "\"."));
    }
  }

  useEffect(function () {
    fn === null || fn === void 0 ? void 0 : fn();
  }, []);
};

export default useMount;